/**
 * section-user-manuals.js
 * CustomModal web component for User Manuals video modals.
 * Handles opening/closing video modals when play/close buttons are clicked.
 */
class CustomModal extends HTMLElement {
  connectedCallback() {
    this._handleClick = this._handleClick.bind(this);
    document.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {Page_Down
    document.removeEventListener('click', this._handleClick);
  }

  /** Parse JS object literal like {type: 'X', action: 'Y', target: 'Z'} */
  _parseAction(str) {
    try {
      var fixed = str
        .replace(/([{,]\s*)(\w+)(\s*:)/g, '$1"$2"$3')
        .replace(/'/g, '"');
      return JSON.parse(fixed);
    } catch (e) { return null; }
  }

  _handleClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = this._parseAction(btn.getAttribute('data-action'));
    if (!action || action.type !== 'Modal' || action.action !== 'toggle') return;
    var videoDiv = btn.closest('.resource--video');
    if (!videoDiv) return;
    var modal = videoDiv.nextElementSibling;
    if (!modal || modal.tagName !== 'CUSTOM-MODAL') return;
    modal.hasAttribute('open') ? this._close(modal) : this._open(modal);
  }

  _getVideoSrc(modal) {
    // Get iframe src from the existing attribute, or build it from data-video-id
    var iframe = modal.querySelector('iframe');
    if (!iframe) return null;
    var src = iframe.getAttribute('src');
    if (src && src.length > 5) return src;
    // If src is empty, build from data-video-id
    var player = modal.querySelector('[data-video-id]');
    if (!player) return null;
    var videoId = player.getAttribute('data-video-id');
    if (!videoId) return null;
    // Strip query string params (e.g. ?si=...) to get just the video ID
    videoId = videoId.split('?')[0];
    return 'https://www.youtube.com/embed/' + videoId + '?rel=0&enablejsapi=1&showinfo=0';
  }

  _open(modal) {
    modal.setAttribute('open', '');
    modal.style.display = 'flex';
    modal.style.opacity = '1';
    modal.style.pointerEvents = 'all';
    document.body.classList.add('modal-open');
    // Load video
    var iframe = modal.querySelector('iframe');
    if (iframe) {
      var src = this._getVideoSrc(modal);
      if (src) iframe.setAttribute('src', src);
    }
    // Show overlay
    var overlay = modal.querySelector('.custom-backdrop');
    if(overlay) {
      overlay.addEventListener('click', () => {
        console.log('Backdrop clicked, closing modal');
        this.closest('custom-modal')._close(modal);
      });
    }
    // if (!overlay) {
    //   overlay = document.createElement('div');
    //   overlay.className = 'custom-modal-overlay';
    //   overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:9997;cursor:pointer;';
    //   var self = this;
    //   overlay.addEventListener('click', function() {
    //     document.querySelectorAll('custom-modal[open]').forEach(function(m) { self._close(m); });
    //   });
    //   document.body.appendChild(overlay);
    // }
    // overlay.style.display = 'block';
  }

  _close(modal) {
    modal.removeAttribute('open');
    modal.style.display = 'none';
    modal.style.opacity = '0';
    modal.style.pointerEvents = 'none';
    document.body.classList.remove('modal-open');
    // Stop video
    var iframe = modal.querySelector('iframe');
    if (iframe) iframe.setAttribute('src', '');
    // Hide overlay
    var overlay = document.querySelector('.custom-modal-overlay');
    if (overlay) overlay.style.display = 'none';
  }
}

if (!customElements.get('custom-modal')) {
  customElements.define('custom-modal', CustomModal);
}
